import { createAction } from '@reduxjs/toolkit';

export const resetStore = createAction('global/resetStore');

export const showReloadModal = createAction<boolean>('global/showReloadModal');